/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Mark_ReadInputs */

const cs_messages_mark_read = /** @type {(inputs: Messages_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako přečtené`)
};

const en_messages_mark_read = /** @type {(inputs: Messages_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark read`)
};

/**
* | output |
* | --- |
* | "Mark read" |
*
* @param {Messages_Mark_ReadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_mark_read = /** @type {((inputs?: Messages_Mark_ReadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Mark_ReadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_mark_read(inputs)
	return cs_messages_mark_read(inputs)
});